;(function() {
  'use strict'

  angular
    .module('ATMGurus')
    .controller('RegisterController', RegisterController)

  RegisterController.$inject = [
    'ApiCustomer',
    '$location',
    'Auth',
    'ErrorService',
    'User',
    '$state',
    '$scope',
    '$rootScope',
    '$timeout'
  ]

  function RegisterController(
    Customer,
    $location,
    Auth,
    ErrorService,
    User,
    $state,
    $scope,
    $rootScope,
    $timeout
  ) {
    var _this = this

    this.pristineStatus = this.status = {
      action: undefined,
      loading: false,
      error: false,
      errorDetails: undefined,
      message: undefined,
      checkingCompany: undefined,
      canRegister: false,
      needAddress: true,
      customerNumberValid: false,
      success: false
    }

    this.email = undefined
    this.data = {
      password: undefined,
      password_confirmation: undefined,
      token: undefined,
      email: undefined
    }
    // default endpoint, we swap it if needed
    this.endpoint = 'customer/register'
    // token for password reset
    this.token = $state.params.token

    /**
     *	Handle title + meta desc
     */
    $rootScope.$emit('meta.refreshed', {
      page_title: 'ATMGurus User Services',
      description: 'Login, register, password reset'
    })

    // if we're coming back from activation
    if ($location.search().activate) {
      this.status.loading = true
      $scope.$emit('modal.open', {
        data: { message: 'We are activating your account please wait.' }
      })
      Customer.activate($location.search().activate)
        .then(response => {
          this.status.loading = false
          this.status.message = response.data.data
          this.status.success = true
          $scope.$emit('modal.close')
        })
        .catch(response => {
          this.status.loading = false
          $scope.$emit('modal.close')
          this.status.success = true
          this.status.error = true
          this.status.message = 'Error: ' + response.data.error
        })
    }

    // if we're coming back from verification
    if ($location.search().verify) {
      $scope.$emit('modal.open', {
        data: { message: 'We are verifying your email address, please wait.' }
      })
      Customer.verify($location.search().verify)
        .then(response => {
          $scope.$emit('modal.close')
          this.status.message = response.data.data
          this.status.success = true
        })
        .catch(response => {
          $scope.$emit('modal.close')
          this.status.success = true
          this.status.error = true
          this.status.message = 'Error: ' + response.data.error
        })
    }

    var formInit = {
      country: { name: 'United States', code: 'US' },
      email: ''
    }

    this.countries = require('../../assets/lib/countries.json')

    this.formDetails = angular.copy(formInit)

    // phone number mask
    _this.mask = '( 999 ) - 999 - 9999'

    /**--------------------------------------------------------
     *	checkCompanyName
     *	check if company name is available
     --------------------------------------------------------*/

    $rootScope.$on('$stateChangeSuccess', function() {
      if (
        $state.current.name === 'userActions.register' &&
        $scope.$parent !== null
      ) {
        triggerUserLinkingModal()
      }
    })

    if ($state.current.name === 'userActions.register') {
      triggerUserLinkingModal()
    }

    function triggerUserLinkingModal() {
      if (
        !angular.isDefined($location.search().activate) &&
        !angular.isDefined($location.search().verify)
      ) {
        $scope.$emit('modal.open', {
          title: 'Link to existing customer',
          template: 'link_customer'
        })
      }
    }

    /**
     *	modals are on the maincontroller, to link it with this controller we need to fire it explicitly in the modal
     *	causing a new digest thus no link with this controller is available. events solves it in a barely bearable manner.
     */
    $rootScope.$on('customerLinked', (event, data) => {
      if (data.success) {
        this.formDetails.customer_number = data.customer_number
        this.endpoint = 'customer/register-user'
        this.status.canRegister = true
        this.status.needAddress = false
        this.status.customerNumberValid = true
      } else {
        if (typeof data.error === 'object') {
          this.status.message = 'Validation Error'
          this.status.errorDetails = data.error
        } else {
          this.status.message = data.error
        }
        this.status.error = true
        this.status.customerNumberValid = false
      }
      $timeout(() => {
        $rootScope.$emit('modal.close')
      }, 500)
      $scope.$digest()
    })

    /**
     *
     *	Submit form and add contact
     *
     */
    this.submit = function() {
      this.status.loading = true
      // $scope.$emit( "modal.open", { data: { message: "We are processing your request, please wait." }} )

      this.status.error = false
      this.status.errorDetails = undefined
      this.status.message = undefined
      this.status.success = false

      var data = angular.copy(this.formDetails)

      data.country = this.formDetails.country.code

      Customer.add(data, this.endpoint)
        .then(response => {
          this.status.loading = false
          // reset form + errors
          this.customerForm.$setPristine()
          this.customerForm.$setUntouched()
          this.formDetails = angular.copy(formInit)
          $scope.$emit('modal.close')
          this.status.message = response.data.data.message
          this.status.error = false
          this.status.success = true
          this.status.errorDetails = undefined
        })
        .catch(response => {
          this.status.loading = false
          $scope.$emit('modal.close')
          this.status.message = 'Validation Errors'
          this.status.error = true
          this.status.success = false
          this.status.errorDetails = response.data.error
        })
    }

    /**
     *
     *	Password recovery
     *
     *
     */
    this.requestPasswordReset = function() {
      this.status.loading = true
      ErrorService.reset('userActions')
      this.status.loading = true
      Auth.passwordRequest(_this.email)
        .then(message => {
          this.status = {
            loading: false,
            error: false,
            success: true,
            message: message
          }
        })
        .catch(message => {
          this.status = {
            loading: false,
            error: true,
            success: false,
            message: message
          }
        })
    }

    /**
     *  describeApiError(reason)
     *
     *  Purpose: turn whatever the API sent back on a failed password call into
     *  plain messages we can show the user. The API answers failures in two shapes:
     *    - its own errors:      { success: false, error: { token: ["message"] } }
     *    - Laravel validation:  { password: ["message"], email: ["message"] }
     *  and sometimes nothing useful at all (e.g. a network error).
     *
     *  Argument: reason = the response body the API rejected with (may be undefined),
     *            or an array of our own messages.
     *  Returns:  an array of plain message strings (possibly empty).
     */
    function describeApiError(reason) {
      // Our own messages are already a list: use them as-is.
      if (angular.isArray(reason)) return reason

      // Pick the object that holds the "field: [messages]" pairs.
      var fields = reason && reason.error ? reason.error : reason
      if (angular.isString(fields)) return [fields]

      // Collect every message from every field into one flat list.
      var messages = []
      angular.forEach(fields, function(value, key) {
        if (key === 'success') return // skip the { success: false } flag itself
        if (angular.isArray(value)) {
          messages = messages.concat(value)
        } else if (angular.isString(value)) {
          messages.push(value)
        }
      })
      return messages
    }

    /**
     *  showPasswordError(reason, headline)
     *
     *  Purpose: show a red box with the API's own reasons, so the user knows WHY
     *  it failed (expired link, passwords don't match, password too short...).
     *  Arguments: reason   = the API's error body, or an array of our own messages
     *             headline = bold first line of the box
     *  Returns: nothing. Updates this.status, which the template displays.
     */
    function showPasswordError(reason, headline) {
      _this.status = {
        loading: false,
        error: true,
        success: false,
        message: headline,
        errorDetails: describeApiError(reason), // one bullet line per message
        // true when the API rejected the emailed link itself (expired / already used),
        // so the reset page can offer to send a new one
        badToken: !!(reason && reason.error && reason.error.token)
      }
      // The Auth service uses native Promises, so ask Angular to redraw the page.
      $scope.$applyAsync()
    }

    /**
     *  showPasswordSuccess(message)
     *
     *  Purpose: show a green "it worked" box.
     *  Argument: message = the text to show.
     *  Returns: nothing. Updates this.status, which the template displays.
     */
    function showPasswordSuccess(message) {
      _this.status = {
        loading: false,
        error: false,
        success: true,
        message: message,
        errorDetails: undefined
      }
      $scope.$applyAsync()
    }

    /**
     *  goToAccountOrLogin()
     *
     *  Purpose: after a password reset, send the user somewhere sensible:
     *  logged in -> "My Account"; not logged in (the usual case) -> login page.
     *  Returns: nothing.
     */
    function goToAccountOrLogin() {
      Auth.isLogged()
        .then(() => $state.go('myaccount.index'))
        .catch(() => $state.go('login'))
    }

    /**
     *  Reset Password: the page reached from the emailed link (/login/reset/<token>).
     *
     *  Sends token + email + new password to POST /api/auth/password/reset.
     *  On success the API answers { success: true, data: { status: "..." } }.
     *  Until 2026-10-22 this read a "message" field the API never sends, so a
     *  successful reset showed nothing at all.
     *
     *  On success: green message, a 3-second pause so it can be read, then on to
     *  the account page (logged in) or the login page (not logged in). The API
     *  does not hand back a login token on reset, so most users go to login.
     */
    this.resetPassword = function() {
      // Ignore double-clicks while the first request is still running.
      if (_this.status.loading) return

      var parms = {
        token: _this.token || undefined,
        email: _this.data.email || undefined,
        password: _this.data.p,
        password_confirmation: _this.data.p_confirm
      }

      // Catch the most common mistake before bothering the server.
      if (!parms.password || parms.password !== parms.password_confirmation) {
        showPasswordError(['The two passwords do not match.'], 'Password not changed')
        return
      }

      _this.status = { loading: true, error: false, message: undefined }

      return Auth.resetPassword(parms)
        .then(() => {
          showPasswordSuccess('Your password has been changed. Taking you on in a moment...')
          $timeout(goToAccountOrLogin, 3000)
        })
        .catch(reason => {
          showPasswordError(reason, 'Password not changed')
        })
    }

    /**
     *  Change Password: My Account -> Change Password (user is logged in).
     *
     *  Changes the password immediately with PUT /api/auth/user. The API only
     *  allows this when the CURRENT password is sent too and is correct.
     *  That endpoint also re-checks the profile fields (first/last name, email,
     *  phone), so we send the user's existing values unchanged.
     *  Until 2026-10-22 this page silently sent a reset email instead.
     */
    this.changePassword = function() {
      if (_this.status.loading) return

      var user = User.getUserData().userDetails || {}

      if (!_this.data.current) {
        showPasswordError(['Please enter your current password.'], 'Password not changed')
        return
      }
      if (!_this.data.p || _this.data.p !== _this.data.p_confirm) {
        showPasswordError(['The two new passwords do not match.'], 'Password not changed')
        return
      }

      var parms = {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone: user.phone,
        current_password: _this.data.current,
        password: _this.data.p,
        password_confirmation: _this.data.p_confirm
      }

      _this.status = { loading: true, error: false, message: undefined }

      // Auth.resetPassword sends this to PUT auth/user because current_password is set.
      return Auth.resetPassword(parms)
        .then(() => {
          // Empty the boxes so the passwords don't linger on screen.
          _this.data.current = _this.data.p = _this.data.p_confirm = undefined
          showPasswordSuccess('Your password has been changed.')
        })
        .catch(reason => {
          showPasswordError(reason, 'Password not changed')
        })
    }

    /**
     *  Email me a reset link: My Account -> Change Password, for users who
     *  don't remember their current password.
     *
     *  POST /api/auth/password/email sends a reset link to the account's address;
     *  we tell the user plainly to go check their inbox.
     */
    this.emailResetLink = function() {
      if (_this.status.loading) return
      _this.status = { loading: true, error: false, message: undefined }

      // No token and no current_password -> Auth sends this to auth/password/email
      // and fills in the logged-in user's email address itself.
      return Auth.resetPassword({})
        .then(() => {
          showPasswordSuccess(
            'Check your inbox: we emailed you a link to reset your password. ' +
              'It can take a few minutes and may land in your spam folder.'
          )
        })
        .catch(reason => {
          showPasswordError(reason, 'We could not send the reset email')
        })
    }
  }
})()



// WEBPACK FOOTER //
// ./src/app/controllers/RegisterController.js